window.isW = false
export default {
  init (op) {
    if (op != null) {
      this.option = op
    }
    if ('WebSocket' in window) {
      this.websocket = new WebSocket(this.option.url)
    }
    // 连接建立时触发
    this.websocket.onopen = () => {
      console.log('websocket建立连接')
      window.isW = true
      this.option.open()
    }
    // 通信发生错误时触发
    this.websocket.onerror = (e) => {
      console.log('websocket发生错误' + JSON.stringify(e))
      this.reconnect()
    }
    // 连接关闭时触发
    this.websocket.onclose = (e) => {
      console.log('websocket连接关闭')
      if (e.wasClean) {
        console.log('websocket服务器连接主动关闭')
        window.isW = false
        this.reconnect()
      }
    }
  },
  // 客户端发送数据
  send (param) {
    // 0:连接尚未建立  1:连接已建立，可以进行通信  2:连接正在进行关闭  3:连接已经关闭或者连接不能打开
    if (this.websocket.readyState === 1) {
      console.log('发送参数:' + JSON.stringify(param))
      this.websocket.send(JSON.stringify(param))
    }
  },
  onmessage (callback) {
    // 客户端接收服务端数据时触发
    this.websocket.onmessage = (event) => {
      callback(event.data)
    }
  },
  close () {
    if (window.isW) {
      // 关闭
      this.websocket.close()
    }
  },
  // 重新连接
  reconnect () {
    if (!window.isW) {
      console.log('重新连接')
      this.websocket = new WebSocket(this.option.url)
      this.getReadyMessage(this.websocket.readyState)
    }
  },
  getReadyMessage (readyState) {
    switch (readyState) {
      case 0:
        console.log('websocket链接还没开启' + new Date())
        break
      case 1:
        console.log('websocket链接开启并准备通信' + new Date())
        break
      case 2:
        console.log('websocket链接正在关闭的过程' + new Date())
        break
      case 3:
        console.log('websocket链接已经关闭' + new Date())
        this.reconnect()
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/webSocket.js